import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { AlertTriangleIcon, HeartIcon, PiggyBankIcon, ClockIcon } from 'lucide-react';
export const Agitation = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-20">
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-21">
        De kosten van niets doen
      </h2>
      <div className="bg-amber-50 p-5 rounded-lg mb-8 border-l-4 border-amber-500" data-id="element-22">
        <h3 className="text-lg font-bold text-amber-800 flex items-center mb-4" data-id="element-23">
          <AlertTriangleIcon className="w-6 h-6 mr-2 text-amber-600" data-id="element-24" />
          Terwijl je dit leest, betaal je elke dag de prijs
        </h3>
        <p className="mb-4 leading-relaxed" data-id="element-25">
          Verlatingsangst (of wat erop lijkt) lost zichzelf niet op. Sterker
          nog, zonder de juiste aanpak wordt het probleem alleen maar erger. De
          kosten zijn hoger dan je misschien beseft.
        </p>
      </div>
      <div className="space-y-6 mb-8" data-id="element-26">
        <div className="flex items-start" data-id="element-27">
          <div className="mr-4 flex-shrink-0" data-id="element-28">
            <HeartIcon className="w-10 h-10 text-red-400" data-id="element-29" />
          </div>
          <div data-id="element-30">
            <h3 className="font-bold text-lg mb-2" data-id="element-31">Jouw persoonlijke kosten</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-32">
              <li data-id="element-33">
                <strong data-id="element-34">Relatieschade:</strong> Je relatie lijdt onder het
                gebrek aan spontaniteit
              </li>
              <li data-id="element-35">
                <strong data-id="element-36">Sociale isolatie:</strong> Vriendschappen verwaateren
                omdat je altijd "nee" moet zeggen
              </li>
              <li data-id="element-37">
                <strong data-id="element-38">Carrière impact:</strong> Je carrière stagneert omdat je
                niet kunt overwerken of netwerken
              </li>
              <li data-id="element-39">
                <strong data-id="element-40">Mental health:</strong> Je leeft in constante stress en
                schuldgevoel
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-start" data-id="element-41">
          <div className="mr-4 flex-shrink-0" data-id="element-42">
            <img src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Angstige hond" className="w-10 h-10 object-cover rounded-full" data-id="element-43" />
          </div>
          <div data-id="element-44">
            <h3 className="font-bold text-lg mb-2" data-id="element-45">De kosten voor je hond</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-46">
              <li data-id="element-47">
                <strong data-id="element-48">Chronische stress:</strong> Die zijn gezondheid aantast
              </li>
              <li data-id="element-49">
                <strong data-id="element-50">Gedragsproblemen:</strong> Angst breidt zich uit naar
                andere gebieden van zijn leven
              </li>
              <li data-id="element-51">
                <strong data-id="element-52">Fysieke gezondheid:</strong> Maagproblemen,
                huidklachten, en andere stress-gerelateerde aandoeningen
              </li>
              <li data-id="element-53">
                <strong data-id="element-54">Kwaliteit van leven:</strong> Hij kan nooit echt
                ontspannen
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-start" data-id="element-55">
          <div className="mr-4 flex-shrink-0" data-id="element-56">
            <PiggyBankIcon className="w-10 h-10 text-green-500" data-id="element-57" />
          </div>
          <div data-id="element-58">
            <h3 className="font-bold text-lg mb-2" data-id="element-59">Financiële kosten</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-60">
              <li data-id="element-61">
                <strong data-id="element-62">Eindeloze trainingskosten:</strong> Die niets oplossen
              </li>
              <li data-id="element-63">
                <strong data-id="element-64">Oppaskosten:</strong> Constant iemand moeten regelen als
                je weg moet
              </li>
              <li data-id="element-65">
                <strong data-id="element-66">Gemiste carrièrekansen:</strong> Die je niet kunt
                benutten
              </li>
              <li data-id="element-67">
                <strong data-id="element-68">Vakanties:</strong> Die je niet kunt boeken
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full mb-6" data-id="element-69">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4NsFBwDm4nyfGxJ8KMzxgA/freepik__the-style-is-candid-image-photography-with-natural__77410.png" alt="Bezorgde vrouw bij het raam terwijl haar hond naar haar opkijkt" className="w-full h-auto rounded-lg shadow-md" data-id="element-70" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-71">
          "Elke dag dat je wacht, wordt het probleem dieper geworteld"
        </p>
      </div>
      <div className="flex items-start mb-6" data-id="element-72">
        <div className="mr-4 flex-shrink-0" data-id="element-73">
          <ClockIcon className="w-10 h-10 text-blue-500" data-id="element-74" />
        </div>
        <div data-id="element-75">
          <h3 className="font-bold text-lg mb-2" data-id="element-76">
            Het wordt alleen maar erger
          </h3>
          <p className="leading-relaxed" data-id="element-77">
            Hoe langer je wacht met de juiste aanpak, hoe dieper deze patronen
            zich nestelen in je hond's brein. Wat nu misschien nog op te lossen
            is in drie maanden, kan over een jaar een permanent probleem worden.
          </p>
          <p className="leading-relaxed mt-2" data-id="element-78">
            Er is een tijdvenster waarin je het probleem relatief eenvoudig kunt
            aanpakken. Na maanden of jaren van versterking wordt het
            exponentieel moeilijker.
          </p>
        </div>
      </div>
      <div className="bg-red-50 p-5 rounded-lg mb-6" data-id="element-79">
        <p className="font-bold text-red-800 mb-2" data-id="element-80">Wist je dat:</p>
        <ul className="list-disc pl-6 space-y-2 text-red-800" data-id="element-81">
          <li data-id="element-82">
            72% van de baasjes van een hond met verlatingsangst voelen zich
            beperkt in hun vrijheid
          </li>
          <li data-id="element-83">
            42% van de relaties ondervindt ernstige spanningen door een hond die
            niet alleen kan blijven
          </li>
          <li data-id="element-84">
            De gemiddelde eigenaar besteedt €1.200 per jaar aan ineffectieve
            trainingen en oppaskosten
          </li>
        </ul>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-85">
        Maar er is goed nieuws. Met de juiste diagnose en behandelen kan een
        hond gemiddeld binnen 3 maanden weer ontspannen alleen te blijven. Geen
        gestressde hond meer, geen schuldgevoel als je toch weg moet, en geen
        beperking van je vrijheid.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-86">
        <FreeConsultLink onClick={openModal} data-id="element-87">
          Plan nu je gratis intake gesprek
        </FreeConsultLink>{' '}
        en zet de eerste stap naar vrijheid voor jou én je hond.
      </p>
    </section>;
};